<template>
  <v-app>
    <!-- Add the top bar and the navigation side menu here -->
    <AccesslinkTopBar @toggleSidemenu="() => {}" :node="node" />

    <v-main>
      <v-container fluid id="accesslink-main-container" style="">

        <v-row class="mt-4 mb-4">
          <v-col offset="10" sm="12" md="8" cols="2" offset-md="2" offset-sm="0" class="d-flex flex-column align-end">
            <v-tooltip
              location="bottom"
              :aria-label="listViewType === 'list' ? $t('menus.topBars.viewAsGrid') : $t('menus.topBars.viewAsList')"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  v-bind="props"
                  @click="toggleListViewType"
                  :elevation="0"
                  :aria-label="listViewType === 'list' ? $t('menus.topBars.viewAsGrid') : $t('menus.topBars.viewAsList')"
                  :aria-pressed="listViewType === 'grid'"
                  :icon="listViewType === 'list' ? 'mdi-view-module' : 'mdi-view-list'"
                  style="border-radius: 10px;"
                />
              </template>

              <span v-if="listViewType === 'list'">{{ $t('menus.topBars.viewAsGrid') }}</span>
              <span v-else-if="listViewType === 'grid'">{{ $t('menus.topBars.viewAsList') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>

        <AccesslinkListView
          v-if="listViewType === 'list'"
          :code="code"
          :pods="nodePods"
          :nodes="[]"
          :currentNodeId="node.id"
        />

        <AccesslinkGridView
          v-if="listViewType === 'grid'"
          :code="code"
          :pods="nodePods"
          :nodes="[]"
          :currentNodeId="node.id"
        />
      </v-container>
    </v-main>

  </v-app>
</template>

<script>
import { useAccesslinkStore } from '@/stores/AccesslinkStore';
import AccesslinkTopBar from "./components/AccesslinkTopBar.vue"
import AccesslinkGridView from '@/routes/accesslink2/components/grid-view/AccesslinkGridView.vue';
import AccesslinkListView from '@/routes/accesslink2/components/list-view/AccesslinkListView.vue';
import { useTheme } from 'vuetify';

export default {
  name: 'AccesslinkNodeView',
  components: {
    AccesslinkListView,
    AccesslinkGridView,
    AccesslinkTopBar,
  },
  data() {
    return {
      code: '',
    };
  },
  mounted() {
    this.code = this.$route.params.code;

    if (!this.getAccessLinkNodes || this.getAccessLinkNodes.length === 0) {
      this.$router.replace({ name: 'accesslink:index' });
      return;
    }

    const theme = useTheme();

    if (
      this.getAccesslinkInfo &&
      this.getAccesslinkInfo.brand &&
      this.getAccesslinkInfo.brand.theme &&
      this.getAccesslinkInfo.brand.theme === 'dark'
    ) {
      theme.change('dark');
    } else {
      theme.change('light');
    }
  },
  methods: {
    toggleListViewType: function() {
      const accesslinkStore = useAccesslinkStore();
      accesslinkStore.toggleListViewType();
    },
  },
  computed: {
    node: function() {
      return this.getAccessLinkNodes.find((node) => node.id === this.$route.params.nodeid);
    },
    nodePods: function() {
      return this.node?.pods;
    },
    getAccesslinkInfo: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getAccesslinkInfo;
    },
    getAccessLinkNodes: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getAccesslinkNodes;
    },
    listViewType: function() {
      const accesslinkStore = useAccesslinkStore();
      return accesslinkStore.getListViewType;
    },
  },
}
</script>

<style lang="scss" scoped>
#accesslink-main-container {
  min-height: 100%;
  padding-top: 80px;
  padding: 16px 12px;
}

@media only screen and (max-width: 600px) {
  #accesslink-main-container {
    padding-top: 76px;
  }
}
</style>
